module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_4_9.b9984272.jpeg";